import { ptBR } from 'date-fns/locale';
import merge from 'lodash/merge';
import error from './error.js';
import login from './login.js';

// Translated by dacampsss

var ptBr = {
  language: 'pt-BR',
  country: 'br',
  name: 'Português',
  embeddedLocale: merge(error, login),
  flags: ['BR', 'PT'],
  dateFns: ptBR,
  format: {
    date: 'd/MM/yyyy',
    dateTime: '$t(format:date) $t(format:time)',
    time: 'HH:mm',
  },
};

export { ptBr as default };
